import { Box, styled } from "@mui/material";

export const Label = styled(Box, {
  shouldForwardProp: (propName) => propName !== "textTransform",
})({
  fontWeight: 500,
  letterSpacing: 0.5,
});
